export const Chevronleft = ({
  fill = "#4B5563",
  width = "20",
  height = "20",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      style={{ position: "relative", top: 3.2 }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_962_8557"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_962_8557)">
        <path
          d="M8.7118 10.0004L12.106 13.3946C12.2214 13.51 12.2804 13.655 12.2831 13.8297C12.2858 14.0044 12.2268 14.1521 12.106 14.2728C11.9853 14.3935 11.8389 14.4539 11.6669 14.4539C11.4949 14.4539 11.3486 14.3935 11.2279 14.2728L7.48268 10.5276C7.40468 10.4496 7.34966 10.3673 7.31761 10.2808C7.28556 10.1943 7.26953 10.1008 7.26953 10.0004C7.26953 9.89994 7.28556 9.80646 7.31761 9.71993C7.34966 9.63339 7.40468 9.55113 7.48268 9.47314L11.2279 5.72795C11.3432 5.61256 11.4883 5.55354 11.6629 5.55087C11.8376 5.54819 11.9853 5.60722 12.106 5.72795C12.2268 5.84867 12.2871 5.99504 12.2871 6.16704C12.2871 6.33904 12.2268 6.4854 12.106 6.60612L8.7118 10.0004Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default Chevronleft;
